import { Injectable } from '@angular/core';
import * as CryptoJS from 'crypto-js';

@Injectable()
export class DataencryptionService {

  dataToEncrypt: string;
  encryptedData: any;

  dataToDecrypt: string;
  decryptedData: any;

  storageEl1: any;
  storageEl2: any;
  storageEl3: any;
  storageEl4: any;

  AESKey = 'AISPL@ADMIN3101';
  // AESKey = 'TEST';
  // AESQRKey = '86D595116837F23E544C25A81B27A';
  // AESKey = 'AISPLKEY93268547';

  constructor() { }

  encryptUID(dataToEncrypt): any {
     return this.encryptedData = CryptoJS.AES.encrypt(dataToEncrypt, this.AESKey);
  }

  decryptUID(dataToDecrypt): any {
    return this.decryptedData = CryptoJS.AES.decrypt(dataToDecrypt, this.AESKey);
  }

  encryptToken(dataToEncrypt): any {
    return this.encryptedData = CryptoJS.AES.encrypt(dataToEncrypt, this.AESKey);
  }

  decryptToken(dataToDecrypt): any {
    return this.decryptedData = CryptoJS.AES.decrypt(dataToDecrypt, this.AESKey);
  }

  encryptAnyData(dataToEncrypt): any {
    return this.encryptedData = CryptoJS.AES.encrypt(dataToEncrypt, this.AESKey);
  }

  decryptAnyData(dataToDecrypt): any {
    return this.decryptedData = CryptoJS.AES.decrypt(dataToDecrypt, this.AESKey);
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/dataencryption.service.ts